namespace GeniuzPOS.PosShift {
    export interface PsVatRefundForm {
        BookNo: Serenity.StringEditor;
        No: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        RefFg: Serenity.RadioButtonEditor;
        RefNo: VatRefundDocFgLookupcustom;
        DocDate: Serenity.DateEditor;
        Passport: Serenity.StringEditor;
        Country: Serenity.LookupEditor;
        Nation: Serenity.LookupEditor;
        FristName: Serenity.StringEditor;
        LastName: Serenity.StringEditor;
        IssueName: Serenity.StringEditor;
        IssueByDate: Serenity.DateEditor;
        FlightNo: Serenity.StringEditor;
        ArriveDate: Serenity.DateEditor;
        DepartureDate: Serenity.DateEditor;
        Addressno: Serenity.StringEditor;
        Street: Serenity.StringEditor;
        District: Serenity.StringEditor;
        City: Serenity.StringEditor;
        Province: Serenity.StringEditor;
        ZipCode: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        DtList: PsVatRefundDtEditor;
        Remark: Serenity.StringEditor;
        Total: Serenity.DecimalEditor;
        Vat: Serenity.DecimalEditor;
        VatRateNo: Serenity.IntegerEditor;
        RoundedVatRefund: Serenity.DecimalEditor;
        PayVatAmount: Serenity.DecimalEditor;
        Status: Serenity.IntegerEditor;
    }

    export class PsVatRefundForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsVatRefund';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsVatRefundForm.init)  {
                PsVatRefundForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.RadioButtonEditor;
                var w2 = VatRefundDocFgLookupcustom;
                var w3 = s.DateEditor;
                var w4 = s.LookupEditor;
                var w5 = PsVatRefundDtEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.IntegerEditor;

                Q.initFormType(PsVatRefundForm, [
                    'BookNo', w0,
                    'No', w0,
                    'DocNo', w0,
                    'ShopId', w0,
                    'RefFg', w1,
                    'RefNo', w2,
                    'DocDate', w3,
                    'Passport', w0,
                    'Country', w4,
                    'Nation', w4,
                    'FristName', w0,
                    'LastName', w0,
                    'IssueName', w0,
                    'IssueByDate', w3,
                    'FlightNo', w0,
                    'ArriveDate', w3,
                    'DepartureDate', w3,
                    'Addressno', w0,
                    'Street', w0,
                    'District', w0,
                    'City', w0,
                    'Province', w0,
                    'ZipCode', w0,
                    'Email', w0,
                    'DtList', w5,
                    'Remark', w0,
                    'Total', w6,
                    'Vat', w6,
                    'VatRateNo', w7,
                    'RoundedVatRefund', w6,
                    'PayVatAmount', w6,
                    'Status', w7
                ]);
            }
        }
    }
}
